import {Hero, LogoSuite, Image, Text} from '@primer/react-brand'
import {Spacer} from './_shared'
import {LOGOS} from './IntroLogos.data'
import {IntroHero} from './IntroHero'
import {useRef, useCallback} from 'react'

export default function Intro() {
  const heroRef = useRef<HTMLDivElement | null>(null)

  const setCopyScrollOpacity = useCallback((copyScrollOpacity: number) => {
    if (heroRef.current) {
      heroRef.current.style.opacity = `${copyScrollOpacity}` // Set the desired opacity value
    }
  }, [])

  const setCopyScrollScale = useCallback((copyScrollScale: number) => {
    if (heroRef.current) {
      heroRef.current.style.transform = `scale(${copyScrollScale})` // Set the desired scale value
    }
  }, [])

  const startCopyAnimation = useCallback(() => {
    if (heroRef.current) {
      heroRef.current.classList.add('is-visible')
    }
  }, [])

  return (
    <section id="hero">
      <div className="lp-Intro">
        {/* Header + Subnav = 136px */}
        <Spacer size="136px" />
        <Spacer size="80px" size1012="96px" />

        <IntroHero
          setCopyScrollOpacity={setCopyScrollOpacity}
          setCopyScrollScale={setCopyScrollScale}
          startCopyAnimation={startCopyAnimation}
        />

        {/* Hero */}
        <Hero ref={heroRef} className="lp-IntroHero sh-CtaWithTrial" data-hpc align="center">
          <Hero.Heading size="2">Build and ship software on a single, collaborative platform</Hero.Heading>

          <Hero.Description size="300">
            Join the world’s most widely adopted, AI-powered developer platform where millions of developers,
            businesses, and the largest open source community build software that advances humanity.
          </Hero.Description>

          <Hero.PrimaryAction href="/signup?source=form-home-signup" hasArrow={false}>
            Sign up
          </Hero.PrimaryAction>
          <Hero.SecondaryAction className="lp-IntroHero-secondaryAction" href="/features/copilot" hasArrow={false}>
            Try GitHub Copilot
            <Text className="sh-CtaWithTrial-label" size="100">
              30 days free
            </Text>
          </Hero.SecondaryAction>
        </Hero>

        <Spacer size="365px" />
        <Spacer size="240px" size1012="300px" />

        {/* Demos */}
        <div className="lp-IntroDemos">
          <Image className="lp-IntroDemos-image" src="/images/modules/site/home24/intro/demo-1.webp" alt="TODO" />
        </div>
      </div>

      <Spacer size="48px" size1012="96px" />

      {/* Logos */}
      <LogoSuite>
        <LogoSuite.Heading visuallyHidden>GitHub is used by</LogoSuite.Heading>
        <LogoSuite.Logobar marquee marqueeSpeed="slow">
          {LOGOS.map((logo, index) => (
            // eslint-disable-next-line @eslint-react/no-array-index-key
            <Image key={index} src={logo.image} alt={logo.alt} style={{height: logo.height}} />
          ))}
        </LogoSuite.Logobar>
      </LogoSuite>
    </section>
  )
}

try{ Intro.displayName ||= 'Intro' } catch {}